import React, { useCallback, useMemo } from "react";

import { css } from "@emotion/react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { GuidedSellingType, GuidedSellingTag } from "@swo/storefront";
import cn from "classnames";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { GuidedSellingStep } from "./subcomponents/GuidedSellingStep";
import { pipe } from "fp-ts/pipeable";
import { nonEmptyArray, option } from "fp-ts";
import { storefrontClient } from "../../domain/storefront";
import { usePageContext } from "../../global/page-context";
import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";

export const GuidedSellingComponent: ReactTFC<GuidedSellingType & ContentfulComponentCMSHook> = props => {
  const {
    pageBase: { locale, segment },
  } = usePageContext();

  const fetchGSResult = useCallback(
    (selectedTags: NonEmptyArray<GuidedSellingTag>) => {
      return storefrontClient
        .guidedSellingResult(
          { localeCode: locale.code, segmentKey: segment.key },
          pipe(
            selectedTags,
            nonEmptyArray.map(tag => tag.sys.id),
          ),
        )
        .then(res => res.data);
      // Just for testing multiple results on results page
      // .then(res => ({ results: [...res.results, ...res.results] }))
    },
    [locale.code, segment.id],
  );

  return (
    <div className={cn(getComponentCMSClassname(props?.sys?.id))} css={styles}>
      <GuidedSellingStep
        initialStep={props.steps}
        fetchGSResult={fetchGSResult}
        localeForNumberFormat={locale}
        translations={props.translations}
        variant={props.width}
      />
    </div>
  );
};

const styles = css`
  display: flex;
  align-items: center;
  flex-direction: column;

  overflow: hidden;
`;
